import { render } from "./AdminCampaignRow.vue?vue&type=template&id=00f129a6&scoped=true"
import script from "./AdminCampaignRow.vue?vue&type=script&lang=js"
export * from "./AdminCampaignRow.vue?vue&type=script&lang=js"

import "./AdminCampaignRow.vue?vue&type=style&index=0&id=00f129a6&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f129a6"]])

export default __exports__